module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_8017.6ece72ed.png";